import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackEvent } from './utils/analytics';

const EXCLUDED_PATHS = ['/support', '/org'];

const shouldExcludeAnalytics = (pathname) => {
    return EXCLUDED_PATHS.some((path) => pathname === path || pathname.startsWith(`${path}/`));
};

const AnalyticsTracker = () => {
    const location = useLocation();

    useEffect(() => {
        const currentPath = location.pathname;

        // -----------------------------------------
        // Do not track support / organizer pages
        // -----------------------------------------
        if (shouldExcludeAnalytics(currentPath)) {
            return;
        }

        const page = currentPath + location.search;

        // -----------------------------------------
        // Prevent duplicate page_view
        // caused by React StrictMode
        // -----------------------------------------
        const storageKey = 'trvto_last_page_view';

        try {
            const previousEvent = sessionStorage.getItem(storageKey);

            if (previousEvent) {
                const parsedEvent = JSON.parse(previousEvent);

                const isSamePage = parsedEvent.page === page;

                const timeDifference = Date.now() - parsedEvent.timestamp;

                // Ignore duplicate event generated
                // within 2 seconds
                if (isSamePage && timeDifference < 2000) {
                    return;
                }
            }

            sessionStorage.setItem(
                storageKey,
                JSON.stringify({
                    page,
                    timestamp: Date.now()
                })
            );
        } catch (error) {
            console.error('Analytics session storage error:', error);
        }

        // -----------------------------------------
        // Track page view
        // -----------------------------------------
        trackEvent({
            event: 'page_view',
            page
        });
    }, [location.pathname, location.search]);

    return null;
};

export default AnalyticsTracker;
